import { z } from 'zod';
import { apiResponseType, providerType, loanIdSchema, requestIdSchema, taxIdSchema, } from '@repo/shared/types';
import { internalErrorResponseSchema, loanDataNotFoundResponseSchema, loanResponseBaseSchema, redisKeyNotFoundResponseSchema, } from './loan-shared.schema';
export var loanCancelRequestBodySchema = z.object({
    requestId: requestIdSchema,
    type: apiResponseType,
    provider: providerType,
    loanId: loanIdSchema,
    reason: z.string(),
});
// Response code 200
export var loanCancelSuccessResponse = loanResponseBaseSchema.and(z.object({
    data: z.object({
        provider: providerType,
        loanId: loanIdSchema,
        taxId: taxIdSchema,
        reason: z.string(),
    }),
}));
// Response code 400
export var loanCancelRedisKeyNotFoundResponseSchema = redisKeyNotFoundResponseSchema;
// Response code 404
export var loanCancelDataNotFoundResponseSchema = loanDataNotFoundResponseSchema;
// Response code 500
export var loanCancelInternalErrorResponseSchema = internalErrorResponseSchema;
